import React, { useCallback, useEffect, useRef, useState } from 'react';
import './reports.scss';
import GlobalParams from '../../helpers/GlobalParams';
import { Button, Form, Menu, Popup } from 'devextreme-react';
import ApiPostHelper from '../../helpers/ApiPostHelper';
import LoadPanel from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { DataGrid, Column, Item } from 'devextreme-react/data-grid';
import ApiHelper from '../../helpers/ApiHelper';
import ReportView from '../ReportView/ReportView';
import { ButtonItem, ButtonOptions, Label, RequiredRule } from 'devextreme-react/cjs/form';
import medical_req_path from '../../templates/MEDICAL_UNDERWRITING_REQUIREMENTS.docx';
import Panel_of_Doctors_path from '../../templates/Panel_of_Doctors.xlsx';
//import XLSX from 'xlsx'; Panel_of_Doctors_path

const Report = () => {

  //////report popup//////////
  const [rptSchemeId, setRptSchemeId] = useState(null);
  const [rptType, setRptType] = useState(1);
  const [AccountMonthStore, setAccountMonthStore] = useState(GlobalParams.AccountMonths);
  const [AccountYearStore, setAccountYearStore] = useState(GlobalParams.AccountYears);
  const [isLoading, setIsLoading] = useState(true);
  const [popupDebitsVisible, setPopupDebitsVisible] = React.useState(false);
  const [popupCreditVisible, setPopupCreditVisible] = React.useState(false);
  const [popupReceiptVisible, setPopupReceiptVisible] = React.useState(false);
  const [DebitsData, setDebitsData] = useState([]);
  const [ReceiptsData, setReceiptsData] = useState([]);
  const [CreditData, setCreditData] = useState([]);
  const [periodStore, setPeriodStore] = useState([]);
  const [popupRptSrchVisible, setPopupRptSrchVisible] = useState(false);
  const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const [rpt_name, setRpt_name] = useState('');
  const [rptUrl, setRptUrl] = useState('');

  function formatNumberWithCommas(value) {
    // Convert value to a string with two decimal places
    const formattedValue = Number(value).toFixed(2);

    // Split the value into integer and decimal parts
    const [integerPart, decimalPart] = formattedValue.split('.');

    // Add commas to the integer part
    const numberWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine the integer part with the decimal part
    return numberWithCommas + '.' + decimalPart;
  }

  const hideReceiptsButtonClick = () => {
    setPopupReceiptVisible(false);
  };

  const hideDebitsButtonClick = () => {
    setPopupDebitsVisible(false);
  };
  const hideCreditButtonClick = () => {
    setPopupCreditVisible(false);
  };
  const hideReportButtonClick = () => {
    setPopupReportVisible(false);
  };
  const hideRptSrchButtonClick = () => {
    setPopupRptSrchVisible(false);
  };
  const emptyItemConfig = {
    itemType: 'empty',
  };
  const doFetchRpt = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);
    //postEndorse(memberStore, 1);
    if (rptType === 1) {//SoA
      setIsLoading(true);

      //TODO - change to dantes reference no fred
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=008&referenceNumber=' + rptSchemeId + '&email=' + GlobalParams.UserEmail +
        '&accountMonth=' + periodStore.AccountMonth + '&accountYear=' + periodStore.AccountYear;

      setRptUrl(url);
      //setPopupReportVisible(true);
      fetchRpt(url);
    } else if (rptType === 2) {//Aging Analysis
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=007&referenceNumber=' + rptSchemeId + '&email=' +
        GlobalParams.UserEmail + '&accountMonth=' + periodStore.AccountMonth + '&accountYear=' + periodStore.AccountYear;

      setRptUrl(url);
      fetchRpt(url);
    }
  }, [periodStore, rptSchemeId]);
  //////end of report popup///

  //////report popup//////////
  const containerRef = useRef(null);
  const renderPdfViewer = (base64PDF) => {
    
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };

  ///////////////excel download///////////
  const downloadExcelFile = (base64Excel, filename) => {
    const blob = base64toBlob(base64Excel, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  };

  const base64toBlob = (base64Data, contentType) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  /*const renderExcelDownloader = (base64Excel, filename) => {
    downloadExcelFile(base64Excel, filename);
  };*/

  /////////////end of excel download/////

  ///////preview excel...............
  const renderExcelPreview = (base64Excel) => {
    // const workbook = XLSX.read(base64toBlobP(base64Excel), { type: 'binary' });
    // const firstSheetName = workbook.SheetNames[0];
    // const worksheet = workbook.Sheets[firstSheetName];
    // const htmlTable = XLSX.utils.sheet_to_html(worksheet);

    // const container = containerRef.current;
    // if (container) {
    //   container.innerHTML = htmlTable;
    // }
  };

  const base64toBlobP = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  };

  /////end of preview excel........

  const fetchRpt = async (url, isCostingSchedule = false) => {
    try {
/*JSON.stringify({
          url_path: url,
        }) */
      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        {}
      );

      /*if (!result.success) {
        setIsLoading(false);
        setPopupReportVisible(false);
        notify("Report Error", 'error', 5000);
      }*/

      setIsLoading(false);
      console.log(result);
      setPopupReportVisible(true);
      // Delay setting isLoading to false until after renderPdfViewer completes
      //let resultpdf = result.substring(1, result.length - 1);
      renderPdfViewer(result);
      // if(isCostingSchedule){
      //   console.log("at displaying the excel file");
      //   downloadExcelFile(result.data, "CostingSchedule.xls");
      // }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      //setIsLoading(false);
    }
  };
  /*const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const hideReportButtonClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }
    setPopupReportVisible(false);
  };*/
  //////end of report popup///

  const [coverPeriodsData, setCoverPeriodsData] = useState([]);
  useEffect(() => {
    fetchCoverPeriods(); // Fetch cover periods when the component mounts
  }, []);


  const onMenuItemClick = (cellInfo, item) => {
    if (item === 'Policy Schedule') {
      console.log('Policy Schedule');
      //setRptSchemeId(cellInfo.data.schemeID);
      //setRptType(1);
      //setPopupRptSrchVisible(true);
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=015&referenceNumber=' + cellInfo.data.schemeID + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);
      fetchRpt(url);
      //Medical Underwriting Requirements
    } else if (item === 'Medical Underwriting Requirements') {
      // Fetch the file
      fetch(medical_req_path)
        .then(response => response.blob()) // Convert the response to a Blob
        .then(blob => {
          // Convert the Blob to Base64
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => {
            // Create a temporary anchor element
            const anchor = document.createElement('a');
            anchor.href = reader.result; // Set the href to the Base64 data URL
            anchor.download = 'MEDICAL UNDERWRITING REQUIREMENTS.docx'; // Set the filename for download
            anchor.click(); // Trigger the download
          };
        })
        .catch(error => console.error('Error fetching the file:', error));
    } else if (item === 'Panel of Doctors') {
      // Fetch the file
      fetch(Panel_of_Doctors_path)
        .then(response => response.blob()) // Convert the response to a Blob
        .then(blob => {
          // Convert the Blob to Base64
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => {
            // Create a temporary anchor element
            const anchor = document.createElement('a');
            anchor.href = reader.result; // Set the href to the Base64 data URL
            anchor.download = 'Panel_of_Doctors.xlsx'; // Set the filename for download
            anchor.click(); // Trigger the download
          };
        })
        .catch(error => console.error('Error fetching the file:', error));
    }
    else if (item === 'Debits') {
      //setMemberName(cellInfo.data.Names);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      console.log('Debits');
      setIsLoading(true);
      fetchDebits(cellInfo.data.schemeID);
    } else if (item === 'Credits') {
      console.log('Credits');
      setIsLoading(true);
      fetchCredits(cellInfo.data.schemeID);
    } else if (item === 'Receipts') {
      console.log('Receipts');
      setIsLoading(true);
      fetchReceipts(cellInfo.data.schemeID);
    } else if (item === 'Statement of Account') {
      console.log('Statement of Account');
      setRptSchemeId(cellInfo.data.schemeID);
      setRptType(1);
      setPopupRptSrchVisible(true);
    } else if (item === 'Aging Analysis') {
      console.log('Aging Analysis');
      setRptSchemeId(cellInfo.data.schemeID);
      setRptType(1);
      setPopupRptSrchVisible(true);//
    } /*else if (item === 'Costing Schedule') {
      console.log('Costing Schedule');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=001&referenceNumber=' + cellInfo.data.schemeID + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);
      fetchRpt(url);
    }*/ else if (item === 'Medical Compliance Report') {
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=016&referenceNumber=' + cellInfo.data.schemeID + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);
      fetchRpt(url);
    }
  };

  const menuItems = [
    // { text: 'Policy Schedule', icon: 'doc' },
    //{ text: 'Panel of Doctors', icon: 'download' },
    //{ text: 'Medical Underwriting Requirements', icon: 'download' },
    //{ text: 'Medical Compliance Report', icon: 'doc' },
    { text: 'Debits', icon: 'doc' },
    { text: 'Credits', icon: 'doc' },
    //{ text: 'Receipts', icon: 'doc' },
    //{ text: 'Statement of Account', icon: 'doc' },
    //{ text: 'Aging Analysis', icon: 'doc' },
    //{ text: 'Costing Schedule', icon: 'doc' }
  ];
  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text="Scheme Info"
            items={menuItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  const fetchCoverPeriods = async () => {
    try {
      //let criteria_map = { gc_id: GlobalParams.ClientId };
      let criteria_map = {
        contact_persons_id: GlobalParams.ContactPersonId,
        client_type: 1
      };
      if (!GlobalParams.IsClientLoggedIn) {
        //criteria_map = { intermediary_id: GlobalParams.IntermediaryId };
        criteria_map = {
          contact_persons_id: GlobalParams.ContactPersonId,
          client_type: 2
        };
      }
      const result = await ApiPostHelper.postData(
        GlobalParams.ApiUrlPrefix + 'policy-cover-periods',
        GlobalParams.bearerToken,
        JSON.stringify(criteria_map)
      );

      setIsLoading(false);
      setCoverPeriodsData(result.data);
    } catch (error) {
      setIsLoading(false);
      //notify("Error fetching the cover periods", 'error', 5000);
      console.error(error);
    }
  };

  const fetchCredits = async (scheme_id) => {
    try {

      // let url = GlobalParams.ApiUrlPrefix + "client-credit-notes?gc_id=" + GlobalParams.ClientId +
      //   "&is_group_client=" + GlobalParams.IsClientLoggedIn;
      // if (GlobalParams.IsClientLoggedIn) {
      let IsClientLoggedIn = 0;
      if (GlobalParams.IsClientLoggedIn) {
        IsClientLoggedIn = 1;
      }
      let url = GlobalParams.ApiUrlPrefix + "client-credit-notes?contact_person_id=" +
        GlobalParams.ContactPersonId + "&is_group_client=" + IsClientLoggedIn;
      //}
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      setPopupCreditVisible(true);
      let tmp_creditsData = result.data;
      tmp_creditsData = tmp_creditsData.filter(creditsData => (parseInt(creditsData.schemeNo) === parseInt(scheme_id)));
      setCreditData(tmp_creditsData);
    } catch (error) {
      setIsLoading(false);
      //notify(error.response.data.message, 'error', 5000);
      // Handle error, e.g., show an error message
      console.log(error);
    }
  };

  const fetchReceipts = async (scheme_id) => {
    try {
      // let url = GlobalParams.ApiUrlPrefix + "client-debit-notes?gc_id=" + GlobalParams.ClientId + 
      // "&is_group_client=" + GlobalParams.IsClientLoggedIn;;
      // if (GlobalParams.IsClientLoggedIn) {
      let url = GlobalParams.ApiUrlPrefix + "get-scheme-receipts?scheme_id=" + scheme_id;
      //}
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      setPopupReceiptVisible(true);
      //let tmp_debitsData = result.data;
      //tmp_debitsData = tmp_debitsData.filter(debitData => parseInt(debitData.schemeNo) === parseInt(scheme_id));
      setReceiptsData(result.data);
    } catch (error) {
      setIsLoading(false);
      //notify(error.response.data.message, 'error', 5000);
      // Handle error, e.g., show an error message
      console.log(error);
    }
  }

  const fetchDebits = async (scheme_id) => {
    try {
      // let url = GlobalParams.ApiUrlPrefix + "client-debit-notes?gc_id=" + GlobalParams.ClientId + 
      // "&is_group_client=" + GlobalParams.IsClientLoggedIn;;
      // if (GlobalParams.IsClientLoggedIn) {
      let IsClientLoggedIn = 0;
      if (GlobalParams.IsClientLoggedIn) {
        IsClientLoggedIn = 1;
      }
      let url = GlobalParams.ApiUrlPrefix + "client-debit-notes?contact_person_id=" + GlobalParams.ContactPersonId +
        "&is_group_client=" + IsClientLoggedIn;
      //}
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      setPopupDebitsVisible(true);
      let tmp_debitsData = result.data;
      tmp_debitsData = tmp_debitsData.filter(debitData => parseInt(debitData.schemeNo) === parseInt(scheme_id));
      setDebitsData(tmp_debitsData);
      
    } catch (error) {
      setIsLoading(false);
      //notify(error.response.data.message, 'error', 5000);
      // Handle error, e.g., show an error message
      console.log(error);
    }
  };

  const onMenuDebitItemClick = (cellInfo, item) => {
    if (item === 'Debit Note') {
      //setMemberName(cellInfo.data.Names);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=002&referenceNumber=' + cellInfo.data.reference + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);

      fetchRpt(url);
    } else if (item === 'Costing Schedule') {
      if (cellInfo.data.isEndorsement === '1' || cellInfo.data.isEndorsement === 1) {
        //display the endorsement one
        setIsLoading(true);
        let url =
          GlobalParams.RptUrlPrefix +
          'reportType=003&referenceNumber=' + cellInfo.data.endorse_no + '&email=' +
          GlobalParams.UserEmail;

        setRptUrl(url);

        fetchRpt(url, true);
      } else {
        setIsLoading(true);
        let url =
          GlobalParams.RptUrlPrefix +
          'reportType=001&referenceNumber=' + cellInfo.data.schemeNo + '&email=' +
          GlobalParams.UserEmail;

        setRptUrl(url);
        fetchRpt(url);
      }

    } else if (item === 'Receipt') {
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=021&referenceNumber=' + cellInfo.data.reference + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);

      fetchRpt(url);
    }
  };

  const menuDebitItems = [
    { text: 'Debit Note', icon: 'doc' },
    { text: 'Costing Schedule', icon: 'doc' },
    //{ text: 'Receipt', icon: 'doc' }
  ];
  const actionDebitsColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuDebitItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuDebitItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  /////credit notes reports///
  const onMenuCreditItemClick = (cellInfo, item) => {
    if (item === 'Credit Note') {
      //setMemberName(cellInfo.data.Names);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      console.log('Credit Note');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=011&referenceNumber=' + cellInfo.data.reference + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);

      fetchRpt(url);
    } else if (item === 'Costing Schedule') {
      if (cellInfo.data.isEndorsement === '1' || cellInfo.data.isEndorsement === 1) {
        //display the endorsement one
        console.log('Endorsement Costing Schedule');
        setIsLoading(true);
        let url =
          GlobalParams.RptUrlPrefix +
          'reportType=003&referenceNumber=' + cellInfo.data.endorse_no + '&email=' +
          GlobalParams.UserEmail;

        setRptUrl(url);

        fetchRpt(url, true);
      } else {
        console.log('Costing Schedule');
        setIsLoading(true);
        let url =
          GlobalParams.RptUrlPrefix +
          'reportType=011&referenceNumber=' + cellInfo.data.schemeNo + '&email=' +
          GlobalParams.UserEmail;

        setRptUrl(url);
        fetchRpt(url);
      }

    }
  };

  const menuCreditItems = [
    { text: 'Credit Note', icon: 'doc' },
    { text: 'Costing Schedule', icon: 'doc' }
  ];
  const actionCreditsColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuCreditItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuCreditItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };
  ////end of credit notes reports//

  ///receipts////////////
  const onMenuReceiptItemClick = (cellInfo, item) => {
    if (item === 'Receipt') {
      //setMemberName(cellInfo.data.Names);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      console.log('Receipt');
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=021&referenceNumber=' + cellInfo.data.idd + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);

      fetchRpt(url);
    }
  };

  const menuReceiptItems = [
    { text: 'Receipt', icon: 'doc' }
  ];
  const actionReceiptColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuReceiptItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuReceiptItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };
  ///end of receipts///


  return (
    <div>
      <LoadPanel visible={isLoading} />
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReportVisible}
          title={report_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReportButtonClick}
        >
          <ReportView
            url={rptUrl}
            onClosePopup={hideReportButtonClick}
          />
        </Popup>
      </div>
      {/*Pop up for rpt search SoA & Aging analysis */}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupRptSrchVisible}
          title={rpt_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideRptSrchButtonClick}
        >

          <div>
            <form onSubmit={doFetchRpt}>
              <Form formData={periodStore}>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <Item
                  dataField="AccountMonth"
                  visible={false}
                  editorType="dxLookup"
                  editorOptions={
                    {
                      dataSource: AccountMonthStore,
                      displayExpr: "name",
                      valueExpr: "id",
                      searchEnabled: true,
                      onValueChanged: (e) => {
                        setPeriodStore({ ...periodStore, AccountMonth: e.value });
                      }
                    }
                  }
                >
                  {true && <RequiredRule message="Account Month is required" />}
                  <Label text='Account Month' />
                </Item>

                <Item
                  dataField="AccountYear"
                  editorType="dxLookup"
                  editorOptions={
                    {
                      dataSource: AccountYearStore,
                      displayExpr: "name",
                      valueExpr: "id",
                      searchEnabled: true,
                      onValueChanged: (e) => {
                        setPeriodStore({ ...periodStore, AccountYear: e.value });
                      }
                    }
                  }
                >
                  {true && <RequiredRule message="Account Year is required" />}
                  <Label text='Account Year' />
                </Item>

                <Item {...emptyItemConfig} />
                <Item {...emptyItemConfig} />

                <ButtonItem
                >
                  <ButtonOptions type='danger' text="SUBMIT" icon='save' useSubmitBehavior={true} />
                </ButtonItem>

              </Form>
            </form>
          </div>

        </Popup>
      </div>

      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupDebitsVisible}
          title={'Debit Notes'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideDebitsButtonClick}
        >
          <div>
            <div>
              {/*List All the debit notes */}

              <div style={{
                paddingTop: '10px',
              }}>
                <div>
                  <div>
                    {
                      <DataGrid
                        dataSource={DebitsData}
                        searchPanel={
                          {
                            visible: true,
                            width: 250
                          }
                        }
                        wordWrapEnabled={true}
                      // onRowClick={(e) => {
                      //   setIsLoading(true);
                      //   let url =
                      //     GlobalParams.RptUrlPrefix +
                      //     'reportType=002&referenceNumber=' + e.data.reference + '&email=' +
                      //     GlobalParams.UserEmail;

                      //   setRptUrl(url);

                      //   fetchRpt(url);
                      // }}
                      >
                        <Column width={50} caption="" visible={false} cellRender={actionDebitsColumnTemplate} />
                        <Column dataField="schemeNo" visible={false}></Column>
                        <Column dataField="reference"></Column>
                        <Column dataField="isEndorsement" dataType='boolean' visible={false}></Column>
                        <Column dataField="endorse_no" visible={false}></Column>
                        <Column dataField="EndorsementNarration" visible={false} caption='Narration'></Column>
                        <Column dataField="trans_date" dataType='date'></Column>
                        <Column dataField="gross_amount" cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.gross_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}>
                        </Column>
                      </DataGrid>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>

      {/* Display Reciepts  */}
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReceiptVisible}
          title={'Receipts'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReceiptsButtonClick}
        >
          <div>
            <div>
              {/*List All the debit notes */}

              <div style={{
                paddingTop: '10px',
              }}>
                <div>
                  <div>
                    {
                      <DataGrid
                        dataSource={ReceiptsData}
                        wordWrapEnabled={true}
                        searchPanel={
                          {
                            visible: true,
                            width: 250
                          }
                        }
                      // onRowClick={(e) => {
                      //   setIsLoading(true);
                      //   let url =
                      //     GlobalParams.RptUrlPrefix +
                      //     'reportType=011&referenceNumber=' + e.data.reference + '&email=' +
                      //     GlobalParams.UserEmail;

                      //   setRptUrl(url);
                      //   //setPopupReportVisible(true);
                      //   fetchRpt(url);
                      // }}
                      >
                        <Column width={50} caption="" cellRender={actionReceiptColumnTemplate} />
                        <Column dataField="schemeNo" visible={false}></Column>
                        <Column dataField="reference"></Column>
                        <Column dataField="isEndorsement" dataType='boolean' visible={false}></Column>
                        <Column dataField="endorse_no" visible={false}></Column>
                        <Column dataField="EndorsementNarration" caption='Narration' visible={false}></Column>
                        <Column dataField="transDate" dataType='date'></Column>
                        <Column dataField="amount" cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}></Column>
                        {/* <Column cellRender={(cellInfo) => {
                          return (
                            <div>
                              <Button
                                text=""
                                type='danger'
                                icon='doc'
                              />
                            </div>
                          );
                        }}>
                        </Column> */}
                      </DataGrid>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>

      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupCreditVisible}
          title={'Credit Notes'}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideCreditButtonClick}
        >
          <div>
            <div>
              {/*List All the debit notes */}

              <div style={{
                paddingTop: '10px',
              }}>
                <div>
                  <div>
                    {
                      <DataGrid
                        dataSource={CreditData}
                        wordWrapEnabled={true}
                        searchPanel={
                          {
                            visible: true,
                            width: 250
                          }
                        }
                      // onRowClick={(e) => {
                      //   setIsLoading(true);
                      //   let url =
                      //     GlobalParams.RptUrlPrefix +
                      //     'reportType=011&referenceNumber=' + e.data.reference + '&email=' +
                      //     GlobalParams.UserEmail;

                      //   setRptUrl(url);
                      //   //setPopupReportVisible(true);
                      //   fetchRpt(url);
                      // }}
                      >
                        <Column width={50} caption="" visible={false} cellRender={actionCreditsColumnTemplate} />
                        <Column dataField="schemeNo" visible={false}></Column>
                        <Column dataField="reference"></Column>
                        <Column dataField="isEndorsement" dataType='boolean' visible={false}></Column>
                        <Column dataField="endorse_no" visible={false}></Column>
                        <Column dataField="EndorsementNarration" visible={false} caption='Narration'></Column>
                        <Column dataField="trans_date" dataType='date'></Column>
                        <Column dataField="gross_amount" cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.gross_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}></Column>
                        {/* <Column cellRender={(cellInfo) => {
                          return (
                            <div>
                              <Button
                                text=""
                                type='danger'
                                icon='doc'
                              />
                            </div>
                          );
                        }}>
                        </Column> */}
                      </DataGrid>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>

      <div>
        <h5 style={{ color: '#2E86C1', fontWeight: 'bold' }}>Schemes</h5>
        {
          <DataGrid
            dataSource={coverPeriodsData}
            searchPanel={
              {
                visible: !GlobalParams.IsClientLoggedIn,
                width: 250
              }
            }
            wordWrapEnabled={true}
          >
            <Column width={130} caption="" cellRender={actionColumnTemplate} />
            <Column dataField="schemeID" visible={false}></Column>
            <Column dataField="PolicyCompany" caption='Scheme' groupIndex={0}></Column>
            <Column dataField="policy_no" visible={false} ></Column>
            <Column dataField="CoverPeriod" visible={false}></Column>
            <Column dataField="DateFrom" visible={false} caption='Cover Start Date' dataType='date'></Column>
            <Column dataField="End_date" visible={false} caption='Cover End Date' dataType='date'></Column>
            <Column dataField="Status" visible={true}></Column>
          </DataGrid>
        }
      </div>
    </div>
  );
};

export default Report;
